<template>
  <div class="pagination-button is-flex">
    <a
      class="pagination-previous"
      :disabled="+pagination < +perPage"
      @click="paginateMinus()"
    >Previous</a>
    <a
      class="pagination-next is-pulled-right"
      :disabled="(+pagination + +perPage) >= total"
      @click="paginatePlus()"
    >Next</a>
  </div>
</template>

<script>
  export default {
    name: 'Pagination',
    props: ['perPage', 'total', 'pagination'],
    data () {
      return {}
    },
    methods: {
      paginateMinus () {
        this.$emit('paginateMinus')
      },
      paginatePlus () {
        this.$emit('paginatePlus')
      }
    }
  }
</script>